// core here
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ModalModule } from 'ngx-bootstrap';
import { FlashMessagesModule } from 'angular2-flash-messages';
import { CustomFormsModule } from 'ng2-validation';

// routing here
import { AppAdminRoutingModule } from './app-admin.routes';

import { reducer } from './common/reducers';
import { AuthEffects } from './common/effects/user';
// component here
import { AppAdminComponent } from './app-admin.component';

// module here
import { LayoutModule } from './layout/layout.module';
import { AuthenticateModule } from './pages/admin/auth/authenticate.module';

import { IContactModule } from './pages/admin/icontact/iContactModule';
// //service here
import { AuthGuard } from './common/services/Auth.guard';
import { ApiEvsService } from './common/services/ApiEvs.service';
import { AuthenticateService } from './common/services/Authenticate.service';
import { ConfirmPhoneGuard } from './confirm-phone.guard';
import { PagerService } from './common/services/Pagination.service';
import { ToastrModule } from 'ngx-toastr';
import { SocketService } from './common/services/Socket.service';
import { TicketService } from './common/services/Ticket.service';
import { ChatService } from './common/services/Chat.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PushNotificationsService } from './common/services/Notifycation.service';
import { ExportService } from './common/services/Export.service';
import { UserSharedService } from './pages/admin/icontact/customer/UserSharedService';
import { SentryErrorHandler } from './sentry';
import { VideoCallComponent } from './pages/admin/icontact/video-call/video-call.component';
import { QuillModule } from 'ngx-quill';
import { SocketListener } from './layout/header/socket.listener';
import { ChatListener } from './pages/admin/icontact/chat/chat.listener';
import { CommonSettingsService } from './common/share-data/common.setting.service';
import { CommonService } from './common/services/Common.service';
import { SharedDataModule } from './common/share-data/shared.data.module';
import { UserService } from './common/services/User.service';
import { GroupService } from './common/services/Group.service';

@NgModule({
  declarations: [AppAdminComponent, VideoCallComponent],
  imports: [
    BrowserModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    StoreModule.provideStore(reducer),
    FlashMessagesModule,
    CustomFormsModule,

    EffectsModule.run(AuthEffects),

    // Admin Module
    AppAdminRoutingModule,
    AuthenticateModule,
    LayoutModule,
    ToastrModule.forRoot(),

    ModalModule.forRoot(),

    IContactModule,
    TooltipModule.forRoot(),
    QuillModule,
    SharedDataModule,
  ],
  providers: [
    AuthGuard,
    AuthenticateService,
    ApiEvsService,
    UserSharedService,
    ConfirmPhoneGuard,
    PagerService,
    SocketService,
    TicketService,
    ChatService,
    PushNotificationsService,
    ExportService,
    SocketListener,
    ChatListener,
    { provide: ErrorHandler, useClass: SentryErrorHandler },
  ],
  bootstrap: [AppAdminComponent],
})
export class AppAdminModule {}



// WEBPACK FOOTER //
// ./src/app/app-admin.module.ts